'use client';
import { useEffect } from "react";
import PropTypes from "prop-types";
import L from "leaflet";
import "leaflet.markercluster/dist/leaflet.markercluster";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import { useMap } from 'react-leaflet/hooks'

const mcg = L.markerClusterGroup();

const MarkerCluster = ({ markers }) => {
    const map = useMap();

    useEffect(() => {
        mcg.clearLayers();
        markers.forEach(({ position, name }) =>{
            console.log(position);
            return (
                L.marker(new L.LatLng(position.lat, position.lng))
                    .addTo(mcg)
                    .bindPopup(name)
            );
        }


        );

        // optionally center the map around the markers
        // map.fitBounds(mcg.getBounds());

        // add the marker cluster group to the map
        // map.addLayer(mcg);
    }, [markers, map]);

    return null;
};

MarkerCluster.propTypes = {
    markers: PropTypes.arrayOf(
        PropTypes.shape({
            position: PropTypes.objectOf(PropTypes.number).isRequired,
            nme: PropTypes.string.isRequired
        }).isRequired
    ).isRequired
};

export default MarkerCluster;
